// avstemming-payroll-messages-part2 translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'ave.sec.src.complete': 'Komplett',
  'ave.sec.src.notRelevant': 'Ikke relevant',
  'ave.sec.row.notCompared': 'Ikke sammenliknet',
  'ave.sec.run.done': 'Fullført og avstemt',
  'ave.sec.run.draft': 'Utkast — ikke bokført',
  'ave.sec.run.ameldingMissing': 'A-melding mangler',
  'ave.sec.run.notPaid': 'Ikke utbetalt',
  'ave.sec.run.paidAfter': 'Utbetalt etter periodedato',
  'ave.sec.sourcesTitle': 'Datakilder',
  'ave.sec.thSource': 'Kilde',
  'ave.sec.thDetails': 'Detaljer',
  'ave.sec.sourcesNote': 'A-melding og bankutbetaling registreres i dag utenfor Plumme. Avstemmingen kan bekrefte at en kjøring er meldt og betalt — ikke hva Altinn eller banken svarte.',
  'ave.sec.mainTitle': 'Automatisk hovedavstemming',
  'ave.sec.nothingToCompare': 'Ingen tall å sammenlikne',
  'ave.sec.deviations': '{count} differanser',
  'ave.sec.mainMatches': 'Lønnssystem og hovedbok stemmer samlet',
  'ave.sec.thArea': 'Kontrollområde',
  'ave.sec.thPayrollSystem': 'Lønnssystem',
  'ave.sec.thLedger': 'Hovedbok',
  'ave.sec.mainNote': '{settled} av {comparable} sammenliknbare kontrollområder stemmer. Tomme celler betyr at kilden ikke har tallet — ikke at beløpet er null.',
  'ave.sec.accountsTitle': 'Kontrollkontoer i hovedboken',
  'ave.sec.noAccounts': 'Ingen kontoer er lagt til lønnsområdet i denne perioden. Uten kontrollkontoer finnes det ingen hovedbokside å sammenlikne lønnssystemet med.',
  'ave.sec.thControlAccount': 'Kontrollkonto',
  'ave.sec.thOpening': 'Inngående saldo',
  'ave.sec.thMovements': 'Periodens bevegelser',
  'ave.sec.thClosing': 'Utgående bokført saldo',
  'ave.sec.thBasis': 'Beregnet grunnlag',
  'ave.sec.accountsNote': 'Gjeldskontoene står med kredit i hovedboken. Sammenlikningen skjer derfor på bevegelsens størrelse — fortegnet er kontoplanens, ikke en feil.',
  'ave.sec.quick.needs': 'Krever vurdering',
  'ave.sec.quick.all': 'Alle',
  'ave.sec.quick.change': 'Unormal lønnsendring',
  'ave.sec.quick.negNet': 'Negativ netto',
  'ave.sec.quick.noAmelding': 'Mangler i A-melding',
  'ave.sec.quick.noTaxCard': 'Mangler skattekort',
  'ave.sec.quick.dup': 'Mulig duplikat',
  'ave.sec.quick.leaver': 'Sluttet ansatt',
  'ave.sec.quick.benefits': 'Naturalytelser',
  'ave.sec.quick.notPaid': 'Ikke utbetalt',
  'ave.sec.quick.done': 'Ferdig vurdert',
  'ave.sec.card.sysVsLedger': 'Lønnssystem mot hovedbok',
  'ave.sec.card.sysVsLedgerHint': 'Kontrollområdene der lønnssystemet og hovedboken ikke gir samme tall.',
  'ave.sec.card.noAmeldingRuns': 'Kjøringer uten A-melding',
  'ave.sec.card.noAmeldingRunsHint': 'Bokførte lønnskjøringer som ikke er registrert som meldt.',
  'ave.sec.card.netUnpaid': 'Netto lønn ikke utbetalt',
  'ave.sec.card.netUnpaidHint': 'Bokførte kjøringer uten registrert utbetaling.',
  'ave.sec.card.dupes': 'Mulige dobbeltutbetalinger',
  'ave.sec.card.dupesHint': 'Samme ansatt med samme bruttobeløp i flere kjøringer i perioden.',
  'ave.sec.card.changes': 'Unormale lønnsendringer',
  'ave.sec.card.changesHint': 'Ansatte med mer enn 30 % avvik fra tidligere kjøringer i året.',
  'ave.sec.card.holidayDiff': 'Feriepengedifferanse',
  'ave.sec.card.holidayDiffHint': 'Beregnet feriepengeforpliktelse mot bokført.',
  'ave.sec.card.negNet': 'Negative nettobeløp',
  'ave.sec.card.negNetHint': 'Lønnslinjer der trekkene overstiger utbetalingen.',
  'ave.sec.card.noTaxCard': 'Ansatte uten gyldig skattekort',
  'ave.sec.card.noTaxCardHint': 'Skattekortet er ikke hentet, eller det er utløpt på utbetalingsdatoen.',
  'ave.sec.card.linesNoAmelding': 'Lønnslinjer uten A-melding',
  'ave.sec.card.linesNoAmeldingHint': 'Linjer i kjøringer som ikke er registrert som meldt.',
  'ave.sec.card.leaver': 'Utbetaling til sluttet ansatt',
  'ave.sec.card.leaverHint': 'Lønn utbetalt etter registrert sluttdato.',
  'ave.sec.card.benefits': 'Naturalytelser til kontroll',
  'ave.sec.card.benefitsHint': 'Lønnslinjer med skattepliktig naturalytelse.',
  'ave.sec.card.accountDev': 'Kontrollkontoer med avvik',
  'ave.sec.card.accountDevHint': 'Kontrollkontoer der bokført bevegelse ikke stemmer med grunnlaget.',
  'ave.sec.card.lines': 'Lønnslinjer i perioden',
  'ave.sec.card.linesHint': 'Alle linjer i de bokførte kjøringene.',
  'ave.sec.card.openTerms': 'Åpne skatte- og avgiftsterminer',
  'ave.sec.card.openTermsHint': 'Terminer med forskuddstrekk eller arbeidsgiveravgift som ikke er gjort opp.',
  'ave.sec.card.checksRun': 'Automatiske kontroller kjørt: {count}',
  'ave.sec.card.checksWithFindings': 'Kontroller med funn: {count}',
  'ave.sec.card.flaggedLines': 'Lønnslinjer med varsel: {count}',
  'ave.sec.card.title': 'Kontrollkort',
  'ave.sec.card.hide': 'Skjul',
  'ave.sec.card.showAll': 'Vis alle automatiske kontroller',
  'ave.sec.noRuns': 'Ingen lønnskjøringer hører til denne perioden. Uten kjøringer finnes det ingen lønn å avstemme.',
  'ave.sec.thPayDate': 'Lønnsdato',
  'ave.sec.thPosted': 'Bokført',
  'ave.sec.voucher': 'Bilag {number}',
  'ave.sec.reported': 'Meldt',
  'ave.sec.afterPeriod': 'Etter periode',
  'ave.sec.runsNote': 'Tallene er kjøringenes egne. Avstemmingen sammenlikner dem med hovedboken — den beregner ikke lønn på nytt.',
  'ave.det.am.noRuns': 'Ingen kjøringer å melde',
  'ave.det.am.allReported': 'Alle kjøringer registrert som meldt',
  'ave.det.am.runsMissing': '{count} kjøringer mangler',
  'ave.det.am.runsReported': 'Kjøringer meldt',
  'ave.det.am.lastSubmitted': 'Sist registrert levert',
  'ave.det.am.recipients': 'Inntektsmottakere i perioden',
  'ave.det.am.grossPerSystem': 'Bruttolønn etter lønnssystemet',
  'ave.det.agaBase': 'Arbeidsgiveravgiftsgrunnlag',
  'ave.det.agaComputed': 'Beregnet arbeidsgiveravgift',
  'ave.det.am.runsWithout': 'Kjøringer uten registrert A-melding',
  'ave.det.am.notReported': 'Ikke meldt',
  'ave.det.am.runLine': '{count} ansatte · {money} brutto · lønnsdato {date}',
  'ave.det.am.openTheRun': 'Åpne kjøringen',
  'ave.det.am.info': 'A-meldingen leveres i Altinn og registreres manuelt i Plumme. Avstemmingen kan derfor bekrefte at en kjøring er meldt — ikke hvilke tall Altinn mottok eller hva tilbakemeldingen sa. Kontroller tilbakemeldingen i Altinn før området sendes til kontroll.',
  'ave.det.bank.noRuns': 'Ingen kjøringer å betale',
  'ave.det.bank.allPaid': 'All netto lønn er registrert utbetalt',
  'ave.det.bank.unpaid': '{money} ikke utbetalt',
  'ave.det.bank.expectedNet': 'Forventet netto lønn',
  'ave.det.bank.registeredPaid': 'Registrert utbetalt',
  'ave.det.bank.thExpected': 'Forventet beløp',
  'ave.det.bank.thPaid': 'Utbetalt',
  'ave.det.bank.thPayDate': 'Betalingsdato',
  'ave.det.bank.note': 'Utbetalt etter {date} er ikke en feil — det er en tidsforskjell. Den må likevel vurderes, fordi forpliktelsen står igjen i balansen ved periodeslutt.',
  'ave.det.tax.withholdingPeriod': 'Forskuddstrekk i perioden',
  'ave.det.tax.openTerms': 'Åpne terminer',
  'ave.det.tax.openAmount': 'Åpent beløp',
  'ave.det.tax.thTerm': 'Termin',
  'ave.det.tax.thDue': 'Forfall',
  'ave.det.tax.thAga': 'Arbeidsgiveravgift',
  'ave.det.tax.paid': 'Betalt',
  'ave.det.tax.thOpen': 'Åpent',
  'ave.det.tax.partlyPaid': 'Delvis betalt',
  'ave.det.tax.notPaid': 'Ikke betalt',
  'ave.det.tax.noTerms': 'Ingen skatte- eller avgiftsterminer berører denne perioden.',
  'ave.det.hol.noAccountBadge': 'Ingen feriepengekonto på området',
  'ave.det.hol.matches': 'Feriepengeforpliktelsen stemmer',
  'ave.det.hol.inDiff': '{money} i differanse',
  'ave.det.hol.opening': 'Inngående feriepengeforpliktelse',
  'ave.det.hol.earned': 'Opptjent i perioden',
  'ave.det.hol.paidOut': 'Utbetalte feriepenger',
  'ave.det.hol.closingComputed': 'Utgående beregnet forpliktelse',
  'ave.det.hol.booked': 'Bokført feriepengeforpliktelse',
  'ave.det.hol.noAccount': 'Ingen feriepengekonto er lagt til lønnsområdet. Uten kontoen finnes det ingen bokført forpliktelse å sammenlikne den beregnede med.',
  'ave.det.hol.agaOnHoliday': 'Arbeidsgiveravgift av feriepenger',
  'ave.det.hol.basis': 'Grunnlag',
  'ave.det.hol.rate': 'Sats',
  'ave.det.hol.computedFee': 'Beregnet avgift',
  'ave.det.hol.postedShort': 'Bokført',
  'ave.det.hol.pensionTitle': 'Pensjon og øvrige trekk',
  'ave.det.hol.pensionPremium': 'Pensjonspremie etter lønnssystemet',
  'ave.det.hol.pensionBooked': 'Bokført pensjon',
  'ave.det.hol.holidayBase': 'Feriepengegrunnlag',
  'ave.det.hol.noPensionAccount': 'Lønnssystemet beregner pensjonspremie, men ingen pensjonskonto er lagt til lønnsområdet. Uten kontoen kan premien ikke avstemmes mot hovedboken.',
  'ave.det.hol.requestPension': 'Be klienten om pensjonsgrunnlag',
  'ave.det.doc.thDocument': 'Dokument',
  'ave.det.doc.thType': 'Type',
  'ave.det.doc.thAdded': 'Lagt til',
  'ave.det.doc.fromClient': 'Fra klienten',
  'ave.det.doc.addedByFirm': 'Lagt til av byrået',
  'ave.det.doc.none': 'Ingen dokumenter er koblet til lønnsområdet i denne perioden.',
  'ave.det.doc.note': 'Lønnsjournal, bokføringsbilag og betalingsgrunnlag ligger på lønnskjøringene selv og er ikke dokumenter noen må laste opp. Det som hører hjemme her er grunnlag som kommer utenfra — pensjonsfaktura, tilbakemelding fra Altinn og avtaler.',
  'ave.drw.as.notAssessed': 'Ikke vurdert',
  'ave.drw.as.noCorrection': 'Ingen korrigering nødvendig',
  'ave.drw.as.realDeviation': 'Reelt avvik — bekreftet',
  'ave.drw.as.payrollError': 'Feil i lønnssystemet — skal rettes',
  'ave.drw.as.postingError': 'Feil bokføring — skal rettes',
  'ave.drw.as.ameldingError': 'Feil i A-melding — krever korrigering',
  'ave.drw.as.paymentError': 'Feil utbetaling',
  'ave.drw.as.timing': 'Tidsforskjell mot bank',
  'ave.drw.as.awaitDocs': 'Avventer dokumentasjon',
  'ave.drw.as.awaitClient': 'Avventer klienten',
  'ave.drw.as.nextPeriod': 'Følges opp neste periode',
  'ave.drw.subtitle': '{run} · {type} · lønnsdato {date}',
  'ave.drw.benefits': 'Naturalytelser',
  'ave.drw.holidayAccrued': 'Feriepenger opptjent',
  'ave.drw.changeFromPrev': 'Endring fra tidligere',
  'ave.drw.noHistory': 'Ingen historikk',
  'ave.drw.reason': 'Begrunnelse',
  'ave.drw.reasonRequired': 'Begrunnelse (påkrevd)',
  'ave.drw.reasonPlaceholder': 'Hva viser gjennomgangen av denne lønnslinjen?',
  'ave.drw.measure': 'Tiltak',
  'ave.drw.measurePlaceholder': 'F.eks. Korriger A-melding eller reverser utbetaling',
  'ave.drw.deadline': 'Frist for oppfølging',
  'ave.drw.followUpNote': 'Lønnslinjen kommer opp som oppfølgingsforslag under «Konklusjon og godkjenning».',
  'ave.drw.needsReason': 'Denne vurderingen krever en begrunnelse.',
  'ave.drw.save': 'Lagre vurdering',
});
